import type { Sku } from '@/types/interfaces/sku'

/** Default description aligned with legacy sku page when refresh config omits `description`. */
export function getSkuRefreshDefaultDescription(sku: Sku): string {
    const isLabPanelSku = sku?.category === 'lab'

    if (isLabPanelSku) {
        return sku.lab_details?.subtitle ?? ''
    }

    return sku.description ?? ''
}
